import { StorageService } from "@app/core/services/storage.service";
import {
  AuthTokenFactory,
  AuthTokenService
} from "@app/core/services/auth-token.service";
import { AuthService } from "@app/core/services/auth.service";
import { AuthAdminService } from "@app/core/services/auth-admin.service";
import { TokenInterceptor } from "@app/core/services/token.interceptor";
import { JsonApiService } from "@app/core/services/json-api.service";
import { UserService } from "@app/core/services/user.service";
import { ChatService } from "@app/core/services/chat.service";
import { NotificationService } from "@app/core/services/notification.service";
import { BodyService } from "@app/core/services/body.service";
import { LayoutService } from "@app/core/services/layout.service";
import { SoundService } from "@app/core/services/sound.service";


import * as fromVoice from '@app/core/services/voice'
import { FirestoreService } from "@app/core/services/firestore.service";
import { ShopsDAO } from "@app/features/shops/shops.dao";
import { OrdersDAO } from "@app/features/orders/orders.dao";
import { OfficeService } from "@app/core/services/office.service";
import { GeocodeService } from "@app/core/services/geocode.service";
import { MessagingService } from "@app/core/services/messaging.service";
import { TrackerService } from "./tracker.service";
import { TaskService } from "./task.service";
import { ExcelService } from "./excel.service";
import { PriceService } from "./price.service";

export const services = [
  StorageService,
  AuthTokenService,
  
  
  AuthService,
  AuthAdminService,
  ShopsDAO,
  OrdersDAO,
  OfficeService,
  TrackerService,
  GeocodeService,
  MessagingService,
  TaskService,
  PriceService,

  ExcelService,

  TokenInterceptor,

  JsonApiService,
  UserService,
  ChatService,
  NotificationService,
  BodyService,
  LayoutService,
  SoundService,
  fromVoice.VoiceControlService,
  fromVoice.VoiceRecognitionService,
];

export * from "@app/core/services/storage.service";
export * from "@app/core/services/auth-token.service";
export * from "@app/core/services/auth.service";
export * from "@app/core/services/firestore.service";
export * from "@app/core/services/messaging.service";
export * from "@app/core/services/geocode.service";
export * from "@app/core/services/auth-admin.service";
export * from "@app/core/services/token.interceptor";
export * from "@app/core/services/json-api.service";
export * from "@app/core/services/user.service";
export * from "@app/core/services/chat.service";
export * from "@app/core/services/notification.service";
export * from "@app/core/services/body.service";
export * from "@app/core/services/layout.service";
export * from "@app/core/services/sound.service";
export * from "@app/core/services/voice";
